import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const dataTableTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      // Table container
      backgroundColor: theme.color.surface[0],
      borderColor: theme.color.surface[3],

      // Header styling
      headerBackgroundColor: theme.color.surface[2],
      headerTextColor: theme.color.text.core['-primary'],
      headerBorderColor: theme.color.surface[3],

      // Row styling
      rowBackgroundColor: theme.color.grid.base,
      rowBackgroundColorEven: theme.color.grid.stripe,
      rowHoverBackgroundColor: theme.color.surface[1],
      rowSelectedBackgroundColor: theme.color.grid.select,
      rowSelectedBorderColor: theme.color.focus[4],
      rowTextColor: theme.color.text.core['-primary'],
      rowBorderColor: theme.color.surface[3],

      // Actions column
      actionsColumnBackgroundColor: theme.color.surface[2],
      actionsColumnBorderColor: theme.color.surface[3],

      // Dropdown/menu styling
      dropdownBackgroundColor: theme.color.surface[1],
      dropdownBorderColor: theme.color.surface[3],
      dropdownTextColor: theme.color.text.core['-primary'],
      dropdownGroupTitleColor: theme.color.text.core['-tertiary'],

      // Resize handle
      resizeHandleColor: theme.color.surface[4],
      resizeHandleHoverColor: theme.color.text.core['-secondary'],

      // Sort indicators
      sortIconColor: theme.color.text.core['-secondary'],
      sortIconActiveColor: theme.color.text.core['-primary'],

      // Scrollbar
      scrollbarTrackColor: theme.color.surface[2],
      scrollbarThumbColor: theme.color.surface[4],
      scrollbarThumbHoverColor: theme.color.text.core['-secondary'],
    },
  ]),
);
